import { createFileRoute, Link } from "@tanstack/react-router";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { AuthLayout } from "@/components/auth/auth-layout";

export const Route = createFileRoute("/confirm-email")({
  component: ConfirmEmailPage,
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, nofollow" },
      { title: "Email confirmed — Spayzo" },
      { name: "description", content: "Your email has been confirmed. Welcome to Spayzo." },
    ],
  }),
});

function ConfirmEmailPage() {
  return (
    <AuthLayout side="right" hideFooter>
      <div className="animate-in fade-in zoom-in-95 duration-500 text-center">
        <div className="relative mx-auto flex h-20 w-20 items-center justify-center">
          <div className="absolute inset-0 rounded-full bg-primary/15 blur-xl" />
          <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-glow">
            <CheckCircle2 className="h-10 w-10" strokeWidth={2.2} />
          </div>
        </div>

        <h1 className="mt-8 font-display text-3xl font-bold tracking-tight sm:text-4xl">
          Email confirmed successfully
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-sm text-muted-foreground">
          Your account is verified and ready. Start exploring spaces or set up your first listing.
        </p>

        <div className="mt-8 space-y-3">
          <Link
            to="/"
            className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-primary px-4 text-sm font-semibold text-primary-foreground shadow-glow transition-all hover:opacity-95 active:scale-[0.99]"
          >
            Continue to app <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/dashboard"
            className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground"
          >
            Go to dashboard
          </Link>
        </div>

      </div>
    </AuthLayout>
  );
}
